import { uniq } from "lodash";
import { useState, useEffect } from "react";
import { dataSourcesService } from "../../../dataFlow";
import { useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";

const baseDescription = ["Showing monthly commodity prices"];

export function useDescription() {
  const [sources, updateSources] = useState("");
  const [commodities] = useParameter<number[]>("@commodities");

  useEffect(() => {
    const getSources = async () => {
      if (commodities != null) {
        const data = await Promise.all(
          commodities.map((commodity) => dataSourcesService.getDataSources(SLIDE_NUMBER, 1, Number(commodity))),
        );
        const sources = data.flatMap((x) => x.split(", "));

        updateSources("Source: " + uniq(sources).join(", "));
      }
    };

    getSources();
  }, [commodities]);

  return baseDescription.concat(sources);
}
